import { useContext } from "react";
import { ApiContext } from "./context";

export const useApiContext = () => useContext(ApiContext);
